/**
 * Server-provided artifact navigation chips (ops report, lien tab, etc.).
 * /s/* downloads stay native so Express serves the PDF (never SPA-routed).
 */
import { Link } from 'react-router-dom'
import type { AriaChatLink } from '../../api/ariaChat'
import { isShareHref } from '../../features/soren/sorenLeavePanel.js'

export default function AriaChatLinkChips({
  links,
  onInternalNav,
}: {
  links: AriaChatLink[]
  onInternalNav?: (href: string) => void
}) {
  if (!links.length) return null
  return (
    <div className="aria-chat-link-chips" data-testid="aria-chat-link-chips">
      {links.map((l) => (
        isShareHref(l.href) ? (
          <a
            key={l.href}
            href={l.href}
            className="aria-chat-link-chip"
            data-testid="aria-chat-link-chip"
          >
            {l.label}
          </a>
        ) : (
          <Link
            key={l.href}
            to={l.href}
            className="aria-chat-link-chip"
            data-testid="aria-chat-link-chip"
            onClick={(e) => {
              if (!onInternalNav) return
              e.preventDefault()
              onInternalNav(l.href)
            }}
          >
            {l.label}
          </Link>
        )
      ))}
    </div>
  )
}
